import { tabs } from './tabs'
import useTabs from '@/hooks/useTabs'
import SubHeaders from '@/components/Headers/SubHeaders'
import { Tabs } from 'vnetwork-ui'

const List = () => {
    const { TabComponent, TabProps } = useTabs({
        tabs: tabs(),
    })
    return (
        <div className="space-y-3">
            <SubHeaders
                actions={[]}
                breadcrumbs={[
                    {
                        path: '/settings/authorization',
                        title: 'Authorization',
                    },
                ]}
            />
            <Tabs {...TabProps} />
            <div>{TabComponent}</div>
        </div>
    )
}

export default List
